<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col col-md-12">
        <h1 class="text-brand-linx">Linx</h1>
        <h4 class="text-brand-product text-uppercase text-truncate text-primary">Microvix</h4>
        <h4 class="text-brand-nome-aplicacao text-uppercase text-truncate text-primary" :title="nomeAplicacao">{{ nomeAplicacao }}</h4>
      </div>
    </div>
    <form @submit.prevent="submit">
      <div class="container mb-3">
        <div class="row">
          <div class="col-12">
            <h3 class="text-uppercase">ALTERAÇÃO DE SENHA - USUÁRIO {{ UsuarioAlteracaoSenha }}</h3>
            <div class="d-flex flex-column-reverse flex-md-row">
              <div class="col-md-6 pl-0">
                <div class="mb-3 form-group">
                  <label class="form-label">Informe a nova senha *</label>
                  <div class="inner-addon">
                    <input
                      :type="exibirOcultarSenha"
                      name="Senha"
                      id="Senha"
                      class="form-control"
                      v-model="Senha"
                      placeholder="Informe a nova senha"
                      maxlength="16"
                      autofocus
                      required
                      @keyup="validarSenhaAoDigitar"
                      :disabled="Executando"
                    />
                    <span class="icon"><font-awesome-icon :icon="iconeExibirOcultarSenha" @click="ExibirSenha = !ExibirSenha" /></span>
                  </div>
                </div>
                <div class="mb-3 form-group">
                  <label class="form-label">Confirme a senha *</label>
                  <div class="inner-addon">
                    <input
                      :type="exibirOcultarConfirmacaoSenha"
                      name="ConfirmeSenha"
                      id="ConfirmeSenha"
                      class="form-control"
                      v-model="ConfirmacaoSenha"
                      placeholder="Confirme a senha"
                      maxlength="16"
                      required
                      @keyup="validarConfirmacaoSenha"
                      :disabled="Executando"
                    />
                    <span class="icon"
                      ><font-awesome-icon :icon="iconeExibirOcultarConfirmacaoSenha" @click="ExibirConfirmacaoSenha = !ExibirConfirmacaoSenha"
                    /></span>
                  </div>
                </div>
              </div>
              <div class="col-md-6 pr-0">
                <div class="alert alert-info" role="alert">
                  <p>A <strong>senha</strong> deverá seguir obrigatoriamente as regras de validação abaixo:</p>

                  <ul class="list-group">
                    <li :class="{ 'text-invalid': !item.Valido }" v-for="(item, index) in ListaRegrasSenha" :key="index">{{ item.Regra }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="alert alert-warning" role="alert">
                  Para correta atualização da sua senha, por favor, certifique-se de que todos os demais produtos Microvix estejam fechados.
                </div>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-lg-2">
                <button class="btn btn-secondary btn-block" type="submit" :disabled="desabilitarBotaoSubmit">
                  ALTERAR
                  <Spinner :loading="Executando" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <img id="outside-logo" src="../../assets/images/xs-logo-mob.png" class="position-absolute r-20 b-40" alt="Logo Linx" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Spinner from '../../components/formulario/spinner.vue';
import swal from '../../utils/alerts';

const regexNumerico = /[0-9]/;
const regexLetra = /[A-Z,a-z]/;

export default {
  name: 'AlteracaoSenha',
  components: {
    Spinner,
  },
  data() {
    return {
      Senha: '',
      ConfirmacaoSenha: '',
      ExibirSenha: false,
      ExibirConfirmacaoSenha: false,
      UsuarioAlteracaoSenha: '',
      Token: '',
      Executando: false,
      SenhaValida: false,
      ListaRegrasSenha: [
        {
          Regra: 'Deverá conter no mínimo 8 caracteres e no máximo 16',
          Valido: true,
        },
        {
          Regra: 'Deverá conter no mínimo uma letra',
          Valido: true,
        },
        {
          Regra: 'Deverá conter no mínimo um número de 0 a 9',
          Valido: true,
        },
        {
          Regra: 'Deverá ser diferente das últimas 5 anteriores, não podendo ser reutilizadas neste período',
          Valido: true,
        },
      ],
    };
  },
  mounted() {
    if (this.$route.query.login) this.UsuarioAlteracaoSenha = this.$route.query.login;

    if (this.$route.query.token) this.Token = this.$route.query.token;
  },
  methods: {
    submit() {
      if (this.SenhaValida) {
        this.Executando = true;
        this.SenhaValida = false;
        this.$store
          .dispatch('alterarSenha', {
            loginUsuario: this.UsuarioAlteracaoSenha,
            token: this.Token,
            novaSenha: this.Senha,
          })
          // eslint-disable-next-line no-unused-vars
          .then(_ => swal.exibirMensagemSucesso('Senha alterada com sucesso', () => this.$router.push({ name: 'Login' }), false))
          .catch(error => {
            const mensagem = error?.response?.data || 'Ocorreu um problema ao alterar a senha';
            swal.exibirMensagemErro(mensagem, () => {}, false);
          })
          .finally((this.Executando = false));
      }
    },
    senhaValidada() {
      this.SenhaValida = this.Senha && this.ListaRegrasSenha.every(r => r.Valido);
    },
    validarSenhaAoDigitar() {
      this.removerUltimoItemListaRegras();
      this.ListaRegrasSenha.forEach(regra => {
        regra.Valido = true;
      });

      if (!this.Senha) return;

      if (this.Senha.length < 8) this.ListaRegrasSenha[0].Valido = false;

      if (this.Senha.length > 16) this.ListaRegrasSenha[0].Valido = false;

      if (!regexLetra.test(this.Senha)) this.ListaRegrasSenha[1].Valido = false;

      if (!regexNumerico.test(this.Senha)) this.ListaRegrasSenha[2].Valido = false;

      this.validarConfirmacaoSenha();
    },
    validarConfirmacaoSenha() {
      if (!this.ConfirmacaoSenha) {
        this.removerUltimoItemListaRegras();
        return;
      }

      this.removerUltimoItemListaRegras();

      if (this.ConfirmacaoSenha !== this.Senha)
        this.ListaRegrasSenha.push({
          Regra: 'A senhas são diferentes',
          Valido: false,
        });

      this.senhaValidada();
    },
    removerUltimoItemListaRegras() {
      if (this.ListaRegrasSenha.length > 4) this.ListaRegrasSenha.splice(this.ListaRegrasSenha.length - 1, 1);
    },
  },
  computed: {
    ...mapState(['nomeAplicacao']),
    exibirOcultarSenha() {
      return this.ExibirSenha ? 'text' : 'password';
    },
    exibirOcultarConfirmacaoSenha() {
      return this.ExibirConfirmacaoSenha ? 'text' : 'password';
    },
    iconeExibirOcultarSenha() {
      return this.ExibirSenha ? ['fa', 'eye'] : ['fa', 'eye-slash'];
    },
    iconeExibirOcultarConfirmacaoSenha() {
      return this.ExibirConfirmacaoSenha ? ['fa', 'eye'] : ['fa', 'eye-slash'];
    },
    desabilitarBotaoSubmit() {
      return !this.SenhaValida || this.Executando;
    },
  },
};
</script>

<style scoped>
.form-group > .inner-addon {
  position: relative;
}

.form-group > .inner-addon > .icon {
  position: absolute;
  right: 0;
  top: 0;
  padding: 8px;
}

.form-group > .inner-addon > .icon > svg {
  color: var(--text-secondary-color);
  cursor: pointer;
}

.list-group {
  list-style-type: none;
}

.text-invalid {
  color: var(--text-error-color);
}

@media only screen and (max-width: 1366px) {
  #outside-logo {
    display: none;
  }
}
</style>
